// import jqueryValidation from 'jquery-validation'; // eslint-disable-line no-unused-vars

export default {
  init() {
    /* all scripts including header, footer etc. */

    const couponToggle = $('.woocommerce-form-coupon-toggle');
    const coupon = $('.checkout_coupon.woocommerce-form-coupon');
    coupon.insertAfter('.shop_table.woocommerce-checkout-review-order-table');
    couponToggle.insertAfter('.shop_table.woocommerce-checkout-review-order-table');

    $('#billing_address_1').attr('placeholder', '');
    $('#account_password').attr('placeholder', '');

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/checkout.js